module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAANlJREFUeNpiZEAD/zuME4CUPxAHoEltAOKNjBVnFyALMiJpFABS64HYgQE/OADEgUCDPsANgGq+D8QCDMQBkGZFkCFMUIH9WDVHzoRgTCAA1cPAAvWzAVZ75IzxucIApJcJGmDkAn8mLKFNCghgYqAQUGwAC17ZThOiXHABpywoFsTU8Om/ADJgIk5pUBpwLsZnwERYSjyPNS3YpDEwfHzOwHB5M1bbgSnREBYGiVhT45FZ+JJyIjwWgCaBwsERb3gg2QxSC9WDyI1o2Tkfi5cugP2Mlp0BAgwAxpU6qC6UUT8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./public/hws/images/required.png
// module id = 353
// module chunks = 0